import INFTSalesList from './INFTSalesList'
import { INFTCollectionItems } from './INFTCollectionItems'

export interface IProfileMenu {
  onSaleList: INFTSalesList[]
  onCollectionList: INFTCollectionItems[]
  activeTab: string
  account: string
}

export interface IProfileTabItem {
  name: string
  tabUrl: string
  noCount?: boolean
}

export enum ProfileTabState {
  ON_SALE = 'on-sale',
  COLLECTION = 'collection',
  ACTIVITY = 'activity'
}
